import { render } from "./CreateFacility.vue?vue&type=template&id=78d583de&scoped=true&ts=true"
import script from "./CreateFacility.vue?vue&type=script&lang=ts"
export * from "./CreateFacility.vue?vue&type=script&lang=ts"

import "./CreateFacility.vue?vue&type=style&index=0&id=78d583de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d583de"]])

export default __exports__